var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 11.3333H3.73692C2.89797 11.3333 2.47849 11.3333 2.39024 11.2682C2.29108 11.195 2.26685 11.1518 2.25612 11.029C2.24656 10.9198 2.50366 10.4991 3.01786 9.65772C3.54875 8.78903 3.99955 7.52415 3.99955 5.73333C3.99955 4.74319 4.42098 3.7936 5.17113 3.09347C5.92127 2.39333 6.93869 2 7.99955 2C9.06042 2 10.0778 2.39333 10.828 3.09347C11.5781 3.7936 11.9996 4.74319 11.9996 5.73333C11.9996 7.52415 12.4504 8.78903 12.9812 9.65772C13.4954 10.4991 13.7525 10.9198 13.743 11.029C13.7323 11.1518 13.708 11.195 13.6089 11.2682C13.5206 11.3333 13.1011 11.3333 12.2622 11.3333H9.99955M6.00065 11.3333L5.99955 12C5.99955 13.1046 6.89498 14 7.99955 14C9.10412 14 9.99955 13.1046 9.99955 12V11.3333M6.00065 11.3333H9.99955",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.38dae383cc377aadfd234f79f76ecc93.svg";
export { ForwardRef as ReactComponent };